import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getLocale, getPhrases, getPhrasesLoading, getPhrasesLoaded, getPhrasesError } from '../redux/selectors';
import { fetchPhrases, setLocale, setDefaultPhrases } from '../redux/actions';

var usePolyglot = function usePolyglot(_ref) {
  var defaultUrl = _ref.defaultUrl,
      defaultLocale = _ref.defaultLocale,
      useDefaultPhrases = _ref.useDefaultPhrases,
      defaultPhrases = _ref.defaultPhrases;
  var locale = useSelector(getLocale);
  var phrases = useSelector(getPhrases);
  var phrasesLoading = useSelector(getPhrasesLoading);
  var phrasesLoaded = useSelector(getPhrasesLoaded);
  var phrasesError = useSelector(getPhrasesError);
  var dispatch = useDispatch();
  var handleFetchPhrases = useCallback(function (url) {
    dispatch(fetchPhrases(url, defaultPhrases));
  }, [dispatch]);
  var handleSetLocale = useCallback(function (locale) {
    dispatch(setLocale(locale));
  }, [dispatch]);
  useEffect(function () {
    if (!phrasesLoaded) {
      if (useDefaultPhrases) {
        dispatch(setDefaultPhrases(defaultPhrases));
      } else {
        handleFetchPhrases(defaultUrl, defaultPhrases);
      }
    }
  }, [phrasesLoaded, handleFetchPhrases, defaultUrl, defaultPhrases]);
  useEffect(function () {
    if (phrasesLoaded) {
      handleSetLocale(defaultLocale);
    }
  }, [phrasesLoaded, handleSetLocale]);
  return {
    locale: locale,
    phrases: phrases,
    phrasesLoading: phrasesLoading,
    phrasesLoaded: phrasesLoaded,
    phrasesError: phrasesError,
    fetchPhrases: handleFetchPhrases,
    setLocale: handleSetLocale
  };
};

export default usePolyglot;